import { render, staticRenderFns } from "./MutualFund.vue?vue&type=template&id=e70862a4&"
import script from "./MutualFund.vue?vue&type=script&lang=js&"
export * from "./MutualFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports